import React from 'react';
import { prettyKey } from 'helpers/formatters';

const ServiceAddress = ({ serviceAddress }) => {
  const fields = ['address1', 'address2', 'city', 'state', 'zip_code'];

  return (
    <table className="table">
      <tbody>
        {fields.map((attr) => (
          <tr key={attr}>
            <th style={{ minWidth: '220px', width: '220px' }}>
              <b>{prettyKey(attr)}</b>
            </th>
            <td>{serviceAddress[attr]}</td>
            <td></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ServiceAddress;
